import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

type NavSiderContextValue = {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  toggle: () => void;
};

const NavSiderContext = createContext<NavSiderContextValue | null>(null);

export function NavSiderProvider({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);

  const toggle = useCallback(() => {
    setCollapsed((current) => !current);
  }, []);

  const value = useMemo(
    (): NavSiderContextValue => ({
      collapsed,
      setCollapsed,
      toggle,
    }),
    [collapsed, toggle],
  );

  return (
    <NavSiderContext.Provider value={value}>
      {children}
    </NavSiderContext.Provider>
  );
}

/** Returns null outside Layout (e.g. embed / public routes without the app sider). */
export function useNavSider(): NavSiderContextValue | null {
  return useContext(NavSiderContext);
}
